import { Fragment, useState, useEffect } from "react"
import {
  useBreakpointValue,
  Box,
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Textarea,
} from "@chakra-ui/react"

import FormField from "../Common/FormField"
import DeleteButton from "../Common/DeleteButton"
import ProductImage from "./ProductImage"
import UploadButton from "./UploadButton"

const CategoryButton = ({ label, isSelected, ...props }) => {
  const firstButtonStyle = useBreakpointValue({
    base: { borderTopLeftRadius: "md", borderTopRightRadius: "md" },
    sm: { borderTopLeftRadius: "md", borderBottomLeftRadius: "md" },
  })
  const lastButtonStyle = useBreakpointValue({
    base: { borderBottomLeftRadius: "md", borderBottomRightRadius: "md" },
    sm: { borderTopRightRadius: "md", borderBottomRightRadius: "md" },
  })

  return (
    <Button
      variant="solid"
      isFullWidth
      colorScheme={isSelected ? "teal" : "gray"}
      zIndex={isSelected ? "100" : null}
      borderRadius={0}
      _first={firstButtonStyle}
      _last={lastButtonStyle}
      fontSize={{ base: "md", sm: "sm", md: "md" }}
      {...props}
    >
      {label}
    </Button>
  )
}

const PriceInput = ({ value, onChange, ...props }) => {
  const format = (val) => val || 0
  const parse = (val) => val

  return (
    <NumberInput
      onChange={(valueString) => onChange(parse(valueString))}
      value={format(value)}
      min={0}
      {...props}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  )
}

const categories = [
  { id: "fresco", label: "Fresco" },
  { id: "gastro", label: "Gastronomia" },
  { id: "mostarde", label: "Mostarde" },
]

const ProductForm = ({
  title,
  item,
  isLoading,
  onSubmit,
  onRemove,
  modalController,
}) => {
  const [name, setName] = useState(item?.name || "")
  const [image, setImage] = useState(item?.image || "")
  const [price, setPrice] = useState(item?.name || "")
  const [description, setDescription] = useState(item?.name || "")
  const [category, setCategory] = useState(item?.category || categories[0].id)

  const onSave = () => {
    onSubmit({
      name,
      image,
      price,
      description,
      category,
    })
    modalController.onClose()
  }

  useEffect(() => {
    setName(item?.name || "")
    setImage(item?.image || "")
    setPrice(item?.price || "")
    setDescription(item?.description || "")
    setCategory(item?.category || categories[0].id)
  }, [item])

  return (
    <Fragment>
      <Modal
        size="xl"
        isOpen={modalController.isOpen}
        onClose={modalController.onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Stack spacing={4}>
              <FormField label="Immagine">
                <Flex
                  align="center"
                  justify="center"
                  px={4}
                  py={4}
                  bg="gray.200"
                  borderRadius="md"
                >
                  <Box width="60%">
                    <UploadButton
                      setIsLoading={(isLoadingImage) => {}}
                      onUploaded={(path) => setImage(path)}
                    >
                      <ProductImage src={image} width="full" showEmpty />
                    </UploadButton>
                  </Box>
                </Flex>
              </FormField>
              <FormField label="Categoria">
                <Flex
                  spacing={{ base: 4, md: 4 }}
                  direction={{ base: "column", sm: "row" }}
                >
                  {categories.map((option) => (
                    <CategoryButton
                      key={option.id}
                      label={option.label}
                      isSelected={option.id === category}
                      onClick={() => setCategory(option.id)}
                    />
                  ))}
                </Flex>
              </FormField>
              <Stack direction="row" spacing={4}>
                <FormField label="Nome" isRequired flex="2">
                  <Input
                    placeholder="Nome"
                    size="md"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </FormField>
                <FormField label="Prezzo" isRequired flex="1">
                  <PriceInput
                    placeholder="Prezzo"
                    size="md"
                    value={price}
                    onChange={(value) => setPrice(value)}
                  />
                </FormField>
              </Stack>
              <FormField label="Descrizione">
                <Textarea
                  placeholder="Descrizione"
                  size="md"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                />
              </FormField>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Flex justify="space-between" w="full">
              {item ? (
                <DeleteButton
                  onClick={() => {
                    onRemove(item.id)
                    modalController.onClose()
                  }}
                  variant="button"
                  mr={3}
                />
              ) : (
                <span></span>
              )}
              <Button
                isLoading={isLoading}
                onClick={onSave}
                colorScheme="teal"
                mr={3}
              >
                Salva
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

export default ProductForm
